import { Component, OnInit } from '@angular/core';
import { I18nService } from '@app/shared/i18n';
import{GraphqlService}from '@app/shared/layout/header/tutorial/graphql.service';
import { Subscription, forkJoin } from 'rxjs';
import { CommonService } from '@app/shared/common/common.service';
import { DomSanitizer } from '@angular/platform-browser';
declare var $: any;
@Component({
  selector: 'app-tutorial',
  templateUrl: './tutorial.component.html',  
})
export class TutorialComponent implements OnInit {
  tutorialHelpOptions: any;
  contentArray=new Array();
  searchArray= new Array();
  displayContent;
  displayItem=false;
  hideSearch=true;
  hideContentRow=true;
  langChangeSubscription: Subscription;
  showLoader=false;
  searchValue="";
  lanId;
  noData=false;
  searchDataId=[];
  searchData=[];
 
  constructor(private i18nService: I18nService,private graphqlService:GraphqlService,private commonService: CommonService,private dom: DomSanitizer) { 
  this.initTutorialPopup();

  $("body").off("click", ".ghp-closeIcon").on("click", ".ghp-closeIcon", (event) => {
    $("#helpTutorial").dialog("close");
    $(".ghp-header-searchBox").val("");
    $('.ghpv-secondary').css({"left":"0px"});
    $('.ghp-header-previousIcon').hide(); 
    this.displayItem=false;
    this.hideContentRow=true;
    this.hideSearch=true;
    this.noData=false;
  });

  $("body").off("click", ".previousIcon").on("click", ".previousIcon", (event) => {
    this.showLoader=true;
    this.contentArray=[];
    this.searchArray=[];
    this.lanId = this.commonService.getCurrentLanguageCode()
    var currentModule:any=JSON.parse(localStorage.getItem('appDetail')).code;
    let query = `{
      pages{
        list(tags:"${currentModule}" orderBy:ID locale:"${this.lanId}"){
            title
            description 
            path
            id
        }
    }
  }`
    $(".ghp-contentFrame").addClass("backgroudView");
    $(".helpLoader").addClass("foreground");
    this.graphqlService.query({"query":query})
    .subscribe(res=>{
      if(res.data.pages.list.length!=0){        
    $(".ghp-contentFrame").removeClass("backgroudView");
    $(".helpLoader").removeClass("foreground");
    $('.ghpv-secondary').css({"left":"0px"});
    $('.ghp-header-previousIcon').hide();    
    this.contentArray=res.data.pages.list;
    this.showLoader=false;
    this.displayItem=false;
    this.hideContentRow=true;
    this.hideSearch=true;
      }
      else{
        $(".ghp-contentFrame").removeClass("backgroudView");
        $(".helpLoader").removeClass("foreground");
        $('.ghpv-secondary').css({"left":"0px"});
        $('.ghp-header-previousIcon').hide();       
        this.displayItem=false;
        this.hideSearch=true;
        this.noData=true;
      }
    });
  });  

  $("body").off("click",".helpContent").on("click",".helpContent",(event)=>{
    this.showLoader=true;
    this.searchArray=[];
    var src="";
    $(".ghp-header-searchRow").addClass("backgroudView");
    $(".helpLoader").addClass("foreground");
   let selectedValue=event.currentTarget.value;
   let selectedqry=`{
    pages {
    single(id:${selectedValue}){
    title
    content
    }
    }
    }`
    this.graphqlService.query({"query":selectedqry})
    .subscribe(result=>{   
      $('.ghpv-secondary').css({"left":"64px", "max-width": "248px"});
      this.hideContentRow=false;
      this.hideSearch=false;
      this.displayItem=true;
      this.noData=false;  
      var base64data;
      var imageItems=[];  
      $('.ghp-header-previousIcon').show();
      var div = document.createElement('div');
      div.innerHTML=result.data.pages.single.content;
      if(div.getElementsByTagName('img').length!=0){
        let imgItems=Array.from(div.getElementsByTagName('img'));
        imgItems.forEach((img,index) => {
          var firstImage = img;
          firstImage.className="image"+index;
          src=firstImage.getAttribute("src"); 
          firstImage.src="";
          imageItems.push(this.graphqlService.getImage('https://wiki.io-market.com'+src));
        });
        forkJoin(imageItems)
        .subscribe(image=>{
          image.forEach((item,index)=>{
            var reader = new FileReader();
            reader.readAsDataURL(item["_body"]); 
            reader.onloadend = ()=>{
              base64data = reader.result; 
              div.getElementsByTagName('img')[index].setAttribute("src",base64data);            
              this.displayContent=div.innerHTML;  
              setTimeout(() => {
                let imgClass="."+div.getElementsByTagName('img')[index].className;
                $(imgClass).css("width","100%");            
                  $(".ghp-header-searchRow").removeClass("backgroudView");
                  $(".helpLoader").removeClass("foreground");
                  this.showLoader=false;                                  
              });             
            }          
          });
        },(err)=>{          
          this.displayContent=result.data.pages.single.content;
          $(".ghp-header-searchRow").removeClass("backgroudView");
          $(".helpLoader").removeClass("foreground");
          this.showLoader=false;
        });
      }else{
        var div = document.createElement('div');        
        div.innerHTML=result.data.pages.single.content;
        let linkElements=Array.from(div.querySelectorAll("a"));
        linkElements.length!=0?linkElements.forEach((link)=>{
          link.className=link.className+"contentLink"
        }):"";
        let headerElements=Array.from(div.querySelectorAll("h1, h2, h3, h4, h5, h6"));
        headerElements.length!=0?headerElements.forEach((ele,index)=>{
          ele.className= ele.className+"heasderLine";
        }):"";
          this.displayContent=div.innerHTML;
          $(".ghp-header-searchRow").removeClass("backgroudView");
          $(".helpLoader").removeClass("foreground");
          this.showLoader=false;  
      }    
    });
    setTimeout(() => {
      $('.ghp-contentFrame a').attr('target', '_blank');
    }, 1000);
  });

$("body").off("keyup",".ghp-header-searchBox").on("keyup",".ghp-header-searchBox",(event)=>{
let searchValue=event.currentTarget.value.toString();
this.searchArray=[];
this.contentArray.length!=0?"":this.noData=true;
if(searchValue!=""){
  this.lanId = this.commonService.getCurrentLanguageCode();
  let currentModule:any=JSON.parse(localStorage.getItem('appDetail')).code;
  $(".ghp-header-searchRow").addClass("backgroudView");
  let searchQuery=`{
    pages {
    search(query:"${searchValue}" locale:"${this.lanId}"){
    results {
    id
    title
    path
    }
    }
    }
    }`
    this.graphqlService.query({"query":searchQuery})
    .subscribe(searchResult=>{
      if(searchResult.data.pages.search.results.length!=0){
        this.searchData=[];
        this.noData=false;
        searchResult.data.pages.search.results.forEach(resItem => {
          if(jQuery.inArray(resItem.id, this.searchDataId) !== -1){
            this.searchData.push(resItem);
          }                   
        });        
        if(this.searchData.length!=0){
          this.searchArray=this.searchData.sort(function(a,b) {
          var titleA=a.title.toLowerCase(), titleB=b.title.toLowerCase()
            if (titleA < titleB) //sort string ascending
                return -1 
            if (titleA > titleB)
                return 1
            return 0 //default return value (no sorting)
        })
      }
      else{
        this.searchArray=[];
        let title=this.i18nService.getTranslation("common_no_data_available");
        this.searchArray.push({"title":title,id:""}); 
        }
      }
      else{
        this.searchArray=[];
        let title=this.i18nService.getTranslation("common_no_data_available")
        this.searchArray.push({"title":title,id:""});           
      }     
    });
}
else{
  this.searchArray=[];
  if(this.contentArray.length!=0){
    $(".ghp-header-searchRow").removeClass("backgroudView");
   } 
}
});


this.langChangeSubscription = this.i18nService.langChangeEvent.subscribe(langObj => this.onLangChange(langObj));
  }

  ngOnInit() {
 
  }

  onLangChange(langObj) {
   this.initTutorialPopup();
   langObj.isHandled = true;
  }
  
  initTutorialPopup() {
    this.tutorialHelpOptions = {
      autoOpen: false,
      modal: true,
      width:600,
      height:700,
      resizable: false,
      closeText: '',
      classes: {
        "ui-dialog": "tutorialItem",
        "ui-dialog-titlebar":"tutorialTitle",
        "ui-dialog-titlebar-close":"tutorialTitleClose",
        "ui-dialog-title":"tutorialMain",
        "ui-dialog-content":"ghp-content"
         },
         open: () => {
          this.initTutorialPopup();
          $('.ghp-header-previousIcon').hide();
         },
      title:"<div class='widget-header'><div class='ghp-header-row'><button class='ghp-header-previousIcon ghp-previousIcon previousIcon ng-scope' aria-label='Go back'></button><h1 class='ghp-header-title ghpv-secondary'>"+this.i18nService.getTranslation('common_all_header_icon_help')+"</h1><button class='ghp-header-closeIcon ghp-closeIcon' aria-label='Close dialog'></button></div></div>"
    };
    $("#helpTutorial").dialog(this.tutorialHelpOptions);
  }


  openTutorial(){
    this.lanId = this.commonService.getCurrentLanguageCode()
    let currentModule:any=JSON.parse(localStorage.getItem('appDetail')).code;
    let query = `{
      pages{
        list(tags:"${currentModule}" orderBy:ID locale:"${this.lanId}"){
            title
            description 
            path
            id
        }
    }
  }`
    this.showLoader=true;
    this.searchArray=[];
    this.contentArray=[];
    this.searchDataId=[];
    $(".ghp-header-searchRow").addClass("backgroudView");
    $(".helpLoader").addClass("foreground");
    $('.ghp-header-previousIcon').hide();
    $('.ghpv-secondary').css({"left":"0px"});    
    $("#helpTutorial").dialog("open");
    this.graphqlService.query({"query":query})
    .subscribe(res=>{ 
      if(res.data.pages.list.length!=0){
        $(".ghp-header-searchRow").removeClass("backgroudView");
        $(".helpLoader").removeClass("foreground");
        this.contentArray=res.data.pages.list;
        this.showLoader=false;
        this.contentArray.forEach(item=>{
          this.searchDataId.push(item.id.toString());
        });
      }
      else{
        this.noData=true;
        this.showLoader=false;
      }
    });
  }


  ngOnDestroy() {
    $("#helpTutorial").dialog("destroy");
    this.langChangeSubscription.unsubscribe();
  }


    
   


}
